import axios from '../../utils/axios'
import { API_BASE_URL } from '../../constants'

// Changes the library chemistry of one of the organisation's own capture kits.
// Returns { id, name, chemistry, own_calling }. Default kits answer 404.
export const updateBedChemistry = async (bedId, chemistry) => {
  const { data } = await axios.patch(`${API_BASE_URL}/bed/${bedId}`, { chemistry })
  return data
}
